import { useState, useEffect, useMemo } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import TanStackTable from '../../../components/TanStackTable';
import { createColumnHelper } from '@tanstack/react-table';
import Chip from '../../../components/Chip';
// Removed unused imports: FaEye, FaCheck, FaTimes, useGetUserDeletionRequests, useNavigate
import { useGetDeletedUsers } from "../../../queries/user";
import { ActionButton } from '../../../components/Forms/ActionButton';

const UserDeletionRequests = () => {

    // Removed navigate - not needed anymore
    // const navigate = useNavigate();

    // Removed activeTab state - now showing only deleted users list
    // const [activeTab, setActiveTab] = useState('requests'); // 'requests' or 'deleted'

    // Removed deletion requests query - not needed anymore
    // const { data, isPending } = useGetUserDeletionRequests();
    const { data: deletedUsers, isPending: isDeletedUsersPending } = useGetDeletedUsers();

    // Removed old request filters - not needed anymore
    // const [filteredData, setFilteredData] = useState([]);
    // const [filters, setFilters] = useState({
    //     fromDate: '',
    //     toDate: '',
    //     status: '',
    //     userName: '',
    // });

    const [filteredDeletedUsers, setFilteredDeletedUsers] = useState([]);
    const [deletedUsersFilters, setDeletedUsersFilters] = useState({
        fromDate: '',
        toDate: '',
        searchTerm: '',
    });

    // Removed old request data effect - not needed anymore
    // useEffect(() => {
    //     if (data) {
    //         setFilteredData(data);
    //     }
    // }, [data]);

    useEffect(() => {
        if (deletedUsers) {
            setFilteredDeletedUsers(deletedUsers);
        }
    }, [deletedUsers]);

    // Removed old request filter handlers - not needed anymore
    // const handleFilterChange = (e) => {
    //     const { name, value } = e.target;
    //     setFilters((prev) => ({ ...prev, [name]: value }));
    // };

    // const handleSearch = (e) => {
    //     e.preventDefault();
    //     let filtered = data;
    //     ... (removed entire function)
    // };

    const handleDeletedUsersFilterChange = (e) => {
        const { name, value } = e.target;
        setDeletedUsersFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleDeletedUsersSearch = (e) => {
        e.preventDefault();
        let filtered = deletedUsers;

        if (deletedUsersFilters.fromDate) {
            filtered = filtered.filter((user) =>
                new Date(user.deletionDate) >= new Date(deletedUsersFilters.fromDate)
            );
        }

        if (deletedUsersFilters.toDate) {
            filtered = filtered.filter((user) =>
                new Date(user.deletionDate) <= new Date(deletedUsersFilters.toDate)
            );
        }

        if (deletedUsersFilters.searchTerm) {
            filtered = filtered.filter((user) => {
                const searchLower = deletedUsersFilters.searchTerm.toLowerCase();
                return user.fullName?.toLowerCase().includes(searchLower) ||
                       user.username?.toLowerCase().includes(searchLower) ||
                       user.email?.toLowerCase().includes(searchLower) ||
                       user.mobile?.includes(searchLower);
            });
        }

        setFilteredDeletedUsers(filtered);
    };

    // Removed old request status chip and columns - not needed anymore
    // const getStatusChip = (request) => { ... };
    // const columns = useMemo(() => [ ... ], []);

    const columnHelper = createColumnHelper();

    // Columns for Deleted Users list
    const deletedUsersColumns = useMemo(() => [
        columnHelper.display({
            id: 'srno',
            header: 'Sr No.',
            cell: info => info.row.index + 1,
        }),
        columnHelper.accessor('fullName', {
            header: 'Full Name',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('username', {
            header: 'Username',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('email', {
            header: 'Email',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('mobile', {
            header: 'Mobile',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('country', {
            header: 'Country',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('state', {
            header: 'State',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('city', {
            header: 'City',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('linkedIn', {
            header: 'LinkedIn',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor('instagram', {
            header: 'Instagram',
            cell: info => info.getValue() || 'N/A',
        }),
        columnHelper.accessor("deletionDate", {
            header: "Deletion Date",
            align: "center",
            cell: (info) => (
                <div className="text-center">
                    {new Date(info.getValue()).toLocaleDateString("en-IN", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                    })}
                    <br />
                    <small className="text-secondary">
                        {new Date(info.getValue()).toLocaleTimeString("en-IN", {
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </small>
                </div>
            ),
        }),
        columnHelper.accessor('deletionType', {
            header: 'Deletion Type',
            cell: info => {
                const type = info.getValue();
                return type === 'user-initiated'
                    ? <Chip value="User Initiated" color="blue" />
                    : <Chip value="Admin Approved" color="purple" />;
            },
        }),
    ], []);

    if (isDeletedUsersPending) {
        return (
            <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">
                <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                    <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                        <h1 className="self-start text-lg font-semibold">Deleted Users List</h1>
                        <p>Loading...</p>
                    </div>
                </section>
            </main>
        );
    }

    return (
        <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">
            {/* Removed Tab Switcher - showing only deleted users list now */}

            {/* Deleted Users List (formerly tab content) */}
            <>
                    {/* Filters for Deleted Users */}
                    <form
                        className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)]"
                        onSubmit={handleDeletedUsersSearch}
                    >
                        <div className='flex items-center justify-between pr-5'>
                            <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap ml-5">
                                <img
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                                    alt=""
                                    className="object-contain shrink-0 w-5 aspect-square"
                                />
                                <span className="self-stretch">Filters</span>
                                <img
                                    loading="lazy"
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                                    alt=""
                                    className="object-contain shrink-0 aspect-square w-[18px]"
                                />
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-4 p-5">
                            <div className='flex gap-3 w-full'>
                                <div className="flex-col w-full">
                                    <label htmlFor="fromDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                        From Date
                                    </label>
                                    <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <input
                                            type="date"
                                            name="fromDate"
                                            value={deletedUsersFilters.fromDate}
                                            onChange={handleDeletedUsersFilterChange}
                                        />
                                    </div>
                                </div>
                                <div className="flex-col w-full">
                                    <label htmlFor="toDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                        To Date
                                    </label>
                                    <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <input
                                            type="date"
                                            name="toDate"
                                            value={deletedUsersFilters.toDate}
                                            onChange={handleDeletedUsersFilterChange}
                                        />
                                    </div>
                                </div>
                                <div className="flex-col w-full">
                                    <label htmlFor="searchTerm" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                        Search
                                    </label>
                                    <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <input
                                            type="text"
                                            name="searchTerm"
                                            value={deletedUsersFilters.searchTerm}
                                            onChange={handleDeletedUsersFilterChange}
                                            placeholder="Search by name, email, username, mobile"
                                            className='outline-none focus:ring-0 w-full'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='flex gap-3 items-center justify-end p-5'>
                            <ActionButton
                                variant={'reset'}
                                text={'Reset'}
                                handleSubmit={() => {
                                    setDeletedUsersFilters({
                                        fromDate: '',
                                        toDate: '',
                                        searchTerm: '',
                                    });
                                    setFilteredDeletedUsers(deletedUsers);
                                }}
                            />
                            <ActionButton
                                variant={'submit'}
                                text={'Search'}
                                handleSubmit={() => { }}
                            />
                        </div>
                    </form>

                    <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                        <div className="flex flex-col pr-px w-full pl-6 max-md:max-w-full">
                            <h1 className="self-start text-lg font-bold pb-4">Deleted Users</h1>
                            {filteredDeletedUsers && filteredDeletedUsers.length > 0 ? (
                                <TanStackTable
                                    data={filteredDeletedUsers}
                                    columns={deletedUsersColumns}
                                    enablePagination={true}
                                />
                            ) : (
                                <div className="pb-4">
                                    No deleted users available
                                </div>
                            )}
                        </div>
                    </section>
            </>

            <ToastContainer
                position="top-right"
                autoClose={3000}
            />
        </main>
    );
}

export default UserDeletionRequests;